import {USER_ROLE_ADMIN, USER_ROLE_SUPER_ADMIN} from '@assets/const/user/roles';
import {getStore} from '@assets/reducers/createStore';

/**
 * @param {User.Info} user
 * @returns {boolean}
 */

export const checkRole = (user = null) => {
  const {user: {data: userData} = {}} = getStore().getState();
  return [USER_ROLE_ADMIN, USER_ROLE_SUPER_ADMIN].some(x => x === userData.account_type);
};
/**
 * @param {User.Info} user
 * @param {Scope} scope
 * @returns {boolean}
 */
export const checkPermission = scope => {
  const {user: {data: userData} = {}} = getStore().getState();
  const {account_type, role} = userData;
  if (account_type === USER_ROLE_SUPER_ADMIN) return true;

  const {resources: prepareResources} = role || {};
  const resources = prepareResources?.split(',');
  if (resources?.includes('all')) return true;

  const isUserView = scope.includes('user.all.view');
  const scopes = scope.split(',');

  return resources?.some(x => (isUserView ? scopes.some(s => x.includes(s)) : scopes.includes(x)));
};
